import { JobRecruitResponse } from '@doda/api-client/aspida/@types';
import { Text } from '@doda/io-react/common';
import { TextWithLF } from '@doda/common/src/components/TextWithLF';
import styles from './index.module.scss';
import { SectionItem } from '../../SectionItem';
import { SubSection } from '../../SubSection';

/**
 * HolidayのProps
 */
export interface Props {
  recruit: JobRecruitResponse;
}

/**
 * 求人詳細 休日・休暇
 */
export const Holiday = ({ recruit }: Props) => {
  const {
    annualHoliday,
    annualHolidayExplanation,
    holidayWeek,
    holidayWeekExplanation,
    nationalHolidayExplanation,
    newYearHolidayExplanation,
    goldenWeekHolidayExplanation,
    summerHolidayExplanation,
    condolenceHolidayExplanation,
    paidHolidaysExplanation,
    maternityHolidayExplanation,
    childcareHolidayExplanation,
    familyCareHolidayExplanation,
    hasNationalHoliday,
    hasNewYearHoliday,
    hasGoldenWeekHoliday,
    hasSummerHoliday,
    hasCondolenceHoliday,
    hasPaidHolidays,
    hasMaternityHoliday,
    hasChildcareHoliday,
    hasFamilyCareHoliday,
    holiday,
  } = recruit;

  const isDisplay =
    annualHoliday !== null ||
    holidayWeek !== null ||
    hasNationalHoliday ||
    hasNewYearHoliday ||
    hasGoldenWeekHoliday ||
    hasSummerHoliday ||
    hasCondolenceHoliday ||
    hasPaidHolidays ||
    hasMaternityHoliday ||
    hasChildcareHoliday ||
    hasFamilyCareHoliday ||
    holiday !== null;

  if (!isDisplay) return null;
  return (
    <SectionItem label="休日・休暇">
      <div className={styles['jobSearchDetail-holiday__items']}>
        {annualHoliday && (
          <SubSection label="年間休日">
            <Text size="14--articlePC" weight="bold">
              {annualHoliday}日{annualHolidayExplanation ?? ''}
            </Text>
          </SubSection>
        )}
        <SubSection label="休日・休暇">
          {holidayWeek && (
            <Text size="14--articlePC">
              {`■${holidayWeek}`}
              {holidayWeek !== holidayWeekExplanation && (
                <>
                  <br />
                  {holidayWeekExplanation ?? ''}
                </>
              )}
            </Text>
          )}
          {hasNationalHoliday && (
            <HolidayItem title="■祝日休み" text={nationalHolidayExplanation} />
          )}
          {hasNewYearHoliday && (
            <HolidayItem
              title="■年末年始休暇"
              text={newYearHolidayExplanation}
            />
          )}
          {hasGoldenWeekHoliday && (
            <HolidayItem title="■GW休暇" text={goldenWeekHolidayExplanation} />
          )}
          {hasSummerHoliday && (
            <HolidayItem title="■夏季休暇" text={summerHolidayExplanation} />
          )}
          {hasCondolenceHoliday && (
            <HolidayItem
              title="■慶弔休暇"
              text={condolenceHolidayExplanation}
            />
          )}
          {hasPaidHolidays && (
            <HolidayItem title="■有給休暇" text={paidHolidaysExplanation} />
          )}
          {hasMaternityHoliday && (
            <HolidayItem
              title="■産前・産後休暇"
              text={maternityHolidayExplanation}
            />
          )}
          {hasChildcareHoliday && (
            <HolidayItem title="■育児休暇" text={childcareHolidayExplanation} />
          )}
          {hasFamilyCareHoliday && (
            <HolidayItem
              title="■介護休暇"
              text={familyCareHolidayExplanation}
            />
          )}
          {holiday && <TextWithLF text={holiday} />}
        </SubSection>
      </div>
    </SectionItem>
  );
};

const HolidayItem = ({
  title,
  text,
}: {
  title: string;
  text: string | undefined;
}) => {
  return (
    <Text size="14--articlePC">
      {title}
      <br />
      {text ?? ''}
    </Text>
  );
};
